import React, { CSSProperties, useEffect } from 'react';

import cn from 'classnames';

import styles from './PageOverlay.module.css';

type StepProps = {
  [key: string]: any;
  active?: boolean;
  children?: React.ReactNode;
  className?: string;
  height: string | number;
  name: string;
  style?: CSSProperties;
  updateContentSize?: (size: { height: string | number; width: string | number }) => void;
  width: string | number;
};

function Step({
  active = false,
  name,
  width,
  height,
  className,
  style,
  updateContentSize = () => {},
  children,
  ...passProps
}: StepProps) {
  useEffect(() => {
    function updateSize() {
      if (active) {
        updateContentSize && updateContentSize({ width, height });
      }
    }

    updateSize();
  }, [active, width, height, updateContentSize]);

  const contentStyle = {
    width,
    height,
    ...style,
  };

  return (
    <div
      className={cn(styles.step, className, {
        [styles.active]: active,
      })}
      style={contentStyle}
      {...passProps}
    >
      {children}
    </div>
  );
}
Step.displayName = 'Step';

export default Step;
